<template>
	<div id="wrap1">
		<div id="wrap2">
			<!-- Main -->
			<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
				<div class="uk-navbar-left">
					<span class="uk-navbar-item uk-logo">出勤情報</span>
				</div>
				<div class="uk-navbar-right">
					<template v-if="current_staff != null">
						<div class="navbar-item">
							<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
						</div>
					</template>
					<div class="navbar-item">
						<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
					</div>
				</div>
			</nav>
			<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
				<div class="uk-align-left">
					<div>
						<el-date-picker id="el_datepicker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" :value="this.params.date" placeholder="YYYY/MM/DD" @input="selectedDatePicker"></el-date-picker>
					</div>
				</div>
				<div class="uk-align-right">
					<button class="uk-button uk-button-primary" @click="showCreateFormDialog">追加</button>
					<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
				</div>
			</div>
			<div id="shop_work_schedule_table_wrap" class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
				<div id="shop_work_schedule_table" class="uk-table uk-table-expand uk-table-striped">
					<div class="thead">
						<div class="row">
							<span>氏名</span>
							<span>出勤情報</span>
							<span>退勤情報</span>
							<span>不在</span>
							<span>設定</span>
							<span>操作</span>
						</div>
					</div>
					<div class="tbody">
						<template v-for="(work_schedule, index) in work_schedules">
							<div class="row data_row" v-bind:data-id="work_schedule.id" :key="index">
								<span>{{ work_schedule.staff.name}}</span>
								<span>{{ work_schedule.start | moment }}</span>
								<span>{{ work_schedule.end | moment }}</span>

								<template v-if="work_schedule.status == 1">
									<span><input class="uk-checkbox" type="checkbox" name="status" checked></span>
								</template>
								<template v-else>
									<span><input class="uk-checkbox" type="checkbox" name="status"></span>
								</template>
								<span><button class="uk-button uk-button-default" @click="showEditForm(work_schedule.id)">設定</button></span>
								<span class="data_row_handle">&#8645;</span>
							</div>
						</template>
						<div class="row">
							<span><button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button></span>
							<span></span>
							<span></span>
							<span></span>
							<span></span>
							<span></span>
						</div>
					</div>
				</div>
			</div>
			<div class="uk-container uk-container-expand uk-margin-small-bottom">
				<div class="uk-align-right">
					<button class="uk-button uk-button-primary" @click="saveEditStaffWorkSchedule">保存</button>
				</div>
			</div>
			<!--/ Main -->

			<!-- CreateFormDialog -->
			<div id="create_form_dialog" uk-modal>
				<div class="uk-modal-dialog uk-modal-body">
					<div class="uk-overflow-hidden">
						<div class="uk-align-left">
							<h2 class="uk-modal-title">追加</h2>
						</div>
						<div class="uk-align-right">
							<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
						</div>
					</div>
					<form id="create_form">
						<div class="uk-form-horizontal">
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="create_form_staff">スタッフ (必須)</label>
								<div class="uk-form-controls">
									<select id="create_form_staff" class="uk-select" name="staff" @change="enableNeedConfirmAlert">
										<template v-for="(staff, index) in staffs">
											<option :key="index" :value="staff.id">{{ staff.name }}</option>
										</template>
									</select>
									<template v-if="typeof this.createFormState.errors.staff_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.staff_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="create_form_date">出勤日 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-date-picker id="create_form_date" name="date" v-model="create_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" @change="changeCreateTime"></el-date-picker>
									</template>
									<template v-else>
										<el-date-picker id="create_form_date" name="date" v-model="create_date_picker" format="yyyy/MM/dd" :type="date" :clearable="false" :picker-options="date_picker_options" @change="changeCreateTime"></el-date-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.date != undefined">
										<template v-for="(error,index) in this.createFormState.errors.date">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="create_form_start">出勤時間 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-time-picker id="create_form_start" v-model="create_start_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
									</template>
									<template v-else>
										<el-time-picker id="create_form_start" v-model="create_start_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.start != undefined">
										<template v-for="(error,index) in this.createFormState.errors.start">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="create_form_end">退勤時間 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-time-picker id="create_form_end" v-model="create_end_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
									</template>
									<template v-else>
										<el-time-picker id="create_form_end" v-model="create_end_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.end != undefined">
										<template v-for="(error,index) in this.createFormState.errors.end">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin">
								<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
							</div>
						</div>
					</form>
				</div>
			</div>
			<!--/ EditFormDialog -->
			<div id="edit_form_dialog" uk-modal>
				<div class="uk-modal-dialog uk-modal-body">
					<div class="uk-overflow-hidden">
						<div class="uk-align-left">
							<h2 class="uk-modal-title">編集</h2>
						</div>
						<div class="uk-align-right">
							<button id="edit_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
						</div>
					</div>
					<form id="edit_form">
						<div class="uk-form-horizontal">
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="edit_form_staff">スタッフ (必須)</label>
								<div class="uk-form-controls">
									<select id="edit_form_staff" class="uk-select" name="staff" @change="enableNeedConfirmAlert">
										<template v-for="(staff, index) in staffs">
											<option :key="index" :value="staff.id">{{ staff.name }}</option>
										</template>
									</select>
									<template v-if="typeof this.createFormState.errors.staff_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.staff_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="edit_form_date">出勤日 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-date-picker id="edit_form_date" name="date" v-model="edit_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" @change="changeEditTime"></el-date-picker>
									</template>
									<template v-else>
										<el-date-picker id="edit_form_date" name="date" v-model="edit_date_picker" format="yyyy/MM/dd" :type="date" :clearable="false" :picker-options="date_picker_options" @change="changeEditTime"></el-date-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.date != undefined">
										<template v-for="(error,index) in this.createFormState.errors.date">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="edit_form_start">出勤時間 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-time-picker id="edit_form_start" v-model="edit_start_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
									</template>
									<template v-else>
										<el-time-picker id="edit_form_start" v-model="edit_start_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.start != undefined">
										<template v-for="(error,index) in this.createFormState.errors.start">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="edit_form_end">退勤時間 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-time-picker id="edit_form_end" v-model="edit_end_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
									</template>
									<template v-else>
										<el-time-picker id="edit_form_end" v-model="edit_end_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.end != undefined">
										<template v-for="(error,index) in this.createFormState.errors.end">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin">
								<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveEditForm">保存</button>
							</div>
						</div>
					</form>
				</div>
			</div>
			<!--/ EditFormDialog -->
		</div>
	</div>
</template>

<script>
	import StaffWorkSchedule from '@/api/StaffWorkSchedule'
	import Staff from '@/api/Staff'
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import Sortable from 'sortablejs'
	import ShopReservation from '@/api/ShopReservation'

	export default {
		name: 'ShopWorkSchedulePage',
		components: {},
		data () {
			return {
				need_confirm_alert: false,
				create_date_picker: moment().format('YYYY/MM/DD'),
				create_start_time_picker: moment().hour(0).minutes(0),
				create_end_time_picker: moment().hour(0).minutes(0),
				edit_date_picker: moment().format('YYYY/MM/DD'),
				edit_start_time_picker: moment().hour(0).minutes(0),
				edit_end_time_picker: moment().hour(0).minutes(0),
				current_staff: null,
				createFormState: {
					errors: []
				},
				params: {
					date: moment().format('YYYY/MM/DD'),
					shop_id: null
				},
				staffs: [],
				work_schedules: [],
				date_picker_options: {
					format: 'yyyy/MM/dd'
				},
				time_picker_options: {
					format: 'HH:mm'
				}

			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			enableNeedConfirmAlert () {
				this.need_confirm_alert = true
			},
			changeCreateTime () {
				this.need_confirm_alert = true

				if (this.create_date_picker == null) {
					this.create_date_picker = moment().format('YYYY/MM/DD')
				}
				if (this.create_start_time_picker == null) {
					this.create_start_time_picker = moment().hour(0).minutes(0)
				}
				if (this.create_end_time_picker == null) {
					this.create_end_time_picker = moment().hour(0).minutes(0)
				}
			},
			changeEditTime () {
				this.need_confirm_alert = true

				if (this.edit_date_picker == null) {
					this.edit_date_picker = moment().format('YYYY/MM/DD')
				}
				if (this.edit_start_time_picker == null) {
					this.edit_start_time_picker = moment().hour(0).minutes(0)
				}
				if (this.edit_end_time_picker == null) {
					this.edit_end_time_picker = moment().hour(0).minutes(0)
				}
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/shop')
						location.reload()
					}
				} else {
					this.$router.push('/shop')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			saveEditStaffWorkSchedule () {
				let self = this
				let length = $('#shop_work_schedule_table .data_row_before_save').length

				let count = -1
				let compare_count = -1
				let reject_count = 0

				$('#shop_work_schedule_table .data_row').each(function (i, element) {
					let status = 0

					if ($(this).find('[name="status"]').prop('checked')) {
						status = 1
					}

					let id = $(this).data('id')
					let order_by = i

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('status', status)
					params.append('order_by', order_by)

					if (status == 1) {
						let tmp_params = new URLSearchParams()
						tmp_params.append('id', id)

						StaffWorkSchedule.one(tmp_params).then(function (response) {
							let start = moment(response.data.data.start).format('YYYY-MM-DD')
							let staff_id = response.data.data.staff_id

							let tmp2_params = new URLSearchParams()
							tmp2_params.append('response_staff_id', staff_id)
							tmp2_params.append('before_date', start)
							tmp2_params.append('after_date', start)

							ShopReservation.one(tmp2_params).then(function (response) {
								let flag1 = response.data.data != null

								let tmp3_params = new URLSearchParams()
								tmp3_params.append('sub_response_staff_id', staff_id)
								tmp3_params.append('before_date', start)
								tmp3_params.append('after_date', start)

								ShopReservation.one(tmp3_params).then(function (response) {
									let flag2 = response.data.data != null
									flag2 = false // 対応者のチェックが不要であれば

									if (flag1 || flag2) {
										compare_count++
										count++
										reject_count++

										$(element).removeClass('data_row_before_save')
										$(element).find('input[type="checkbox"]').prop('checked', false)
									} else {
										compare_count++
										StaffWorkSchedule.update(params).then(function () {
											count++
										})
									}
								})
							})
						})
					} else {
						compare_count++
						StaffWorkSchedule.update(params).then(function () {
							count++
						})
					}
				})

				let intervalID = setInterval(function () {
					if (count != -1 && compare_count != -1 && count == compare_count) {
						clearInterval(intervalID)

						setTimeout(function () {
							if (reject_count > 0) {
								alert('[' + reject_count + '件] 予約枠が割り当てられているため不在にできませんでした。※ゴミ箱内も要確認')
							}

							alert('保存完了')
							location.reload()
						}, 500)
					}
				}, 300)
			},
			showEditForm (id) {
				this.need_confirm_alert = false

				let self = this
				let staff_work_schedule_id = id

				StaffAuth.current().then(function (response) {
					let staff = response.data.data

					let params = new URLSearchParams()
					params.append('id', id)

					StaffWorkSchedule.one(params).then(function (response) {
						self.edit_start_time_picker = moment(response.data.data.start)

						self.edit_end_time_picker = moment(response.data.data.end)

						$('#edit_form').data('id', id)
						// $('#edit_form [name="date"]').val(moment(response.data.data.start).format('YYYY/MM/DD'))
						self.edit_date_picker = moment(response.data.data.start)
						$('#edit_form [name="staff"] option[value="' + response.data.data.staff_id + '"]').prop('selected', true)

						UIkit.modal($('#edit_form_dialog'), {container: '#app div', bgClose: false}).show()
					})
				})
			},
			saveEditForm () {
				let self = this

				StaffAuth.current().then(function (response) {
						self.need_confirm_alert = false

						let staff = response.data.data

						let id = $('#edit_form').data('id')
						let date = moment(self.edit_date_picker).format('YYYY-MM-DD')
						let start = moment(self.edit_start_time_picker).format('HH:mm')
						let end = moment(self.edit_end_time_picker).format('HH:mm')
						let staff_id = $('#edit_form [name="staff"]').val()

						let params = new URLSearchParams()
						params.append('id', id)
						params.append('start', moment(date + ' ' + start).format('YYYY-MM-DD HH:mm:ss'))
						params.append('end', moment(date + ' ' + end).format('YYYY-MM-DD HH:mm:ss'))
						params.append('staff_id', staff_id)
						params.append('shop_id', staff.shop_id)

						// 重複チェック

						let params_tmp = new URLSearchParams()
						params_tmp.append('before_start_date', moment(date + ' ' + start).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
						params_tmp.append('after_start_date', moment(date + ' ' + start).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
						params_tmp.append('staff_id', staff_id)

						StaffWorkSchedule.all(params_tmp).then(function (response) {
							let flag = true

							if (response.data.data.length != 0) {
								response.data.data.forEach(function (value) {
									if (value.id != id) {
										flag = false
									}
								})

								if (flag) {
									StaffWorkSchedule.update(params).then(function (response) {
										alert('保存完了')
										location.reload()
									}).catch(function (error) {
										self.createFormState.errors = error.response.data.errors
									})
								} else {
									alert('出勤情報が重複するため編集できません。')
								}
							} else {
								StaffWorkSchedule.update(params).then(function (response) {
									alert('保存完了')
									location.reload()
								}).catch(function (error) {
									self.createFormState.errors = error.response.data.errors
								})
							}
						})
					}
				)
			},
			saveCreateForm () { // ダイアログ保存
				this.need_confirm_alert = false
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data

					let date = moment(self.create_date_picker).format('YYYY-MM-DD')
					let start = moment(self.create_start_time_picker).format('HH:mm')
					let end = moment(self.create_end_time_picker).format('HH:mm')
					let staff_id = $('#create_form [name="staff"]').val()
					// let order_by = $('#shop_work_schedule_table .data_row').length
					let order_by = 99999

					let params = new URLSearchParams()
					params.append('start', moment(date + ' ' + start).format('YYYY-MM-DD HH:mm:ss'))
					params.append('end', moment(date + ' ' + end).format('YYYY-MM-DD HH:mm:ss'))
					params.append('staff_id', staff_id)
					params.append('shop_id', staff.shop_id)
					params.append('order_by', order_by)

					// 重複チェック

					let params_tmp = new URLSearchParams()
					params_tmp.append('before_start_date', moment(date + ' ' + start).format('YYYY-MM-DD HH:mm:ss'))
					params_tmp.append('after_start_date', moment(date + ' ' + start).format('YYYY-MM-DD HH:mm:ss'))
					params_tmp.append('staff_id', staff_id)

					StaffWorkSchedule.all(params_tmp).then(function (response) {
						if (response.data.data != 0) {
							alert('出勤情報が重複するため追加できません。')
						} else {
							StaffWorkSchedule.create(params).then(function (response) {
								alert('保存完了')
								location.reload()
							}).catch(function (error) {
								if (error.response.status == '400') {
									if (error.response.data.message == 'NOT EXISTS STAFF') {
										alert('対象スタッフが存在しないため追加できません。\nダイアログを閉じ画面を更新してから、再度実行してください。')
									} else if (error.response.data.message == 'THIS IS EXISTS DATETIME') {
										alert('出勤情報が重複するため登録できません。')
									} else {
										alert(error.response.data.message)
									}
								} else {
									self.createFormState.errors = error.response.data.errors
								}
							})
						}
					})
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				this.create_start_time_picker = moment().hour(0).minutes(0)
				this.create_end_time_picker = moment().hour(0).minutes(0)

				this.need_confirm_alert = false
				this.create_date_picker = moment(this.params.date).format('YYYY/MM/DD')

				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			/* datePickerFormat (date) {
				return moment(date).format('YYYY-MM-DD (dddd)')
			}, */
			selectedDatePicker (date) {
				if (date == null) {
					// this.params.date = ''
				} else {
					this.params.date = moment(date).format('YYYY/MM/DD')
					this.$router.push('/shop/work_schedule/' + moment(date).format('YYYY-MM-DD'))
					location.reload()
				}
			},
			loadParams () {
				let self = this

				if (this.$route.params.date != null) {
					this.params.date = moment(this.$route.params.date).format('YYYY/MM/DD')
				}
			},
			loadStaffs () {
				let self = this

				StaffAuth.current().then(function (response) {
					self.shop_id = response.data.data.shop_id

					let params = new URLSearchParams()
					params.append('shop_id', response.data.data.shop_id)

					Staff.all(params).then(function (response) {
						self.staffs = response.data.data
					})
				})
			},
			loadWorkSchedules () {
				let self = this

				StaffAuth.current().then(function (response) {
					self.params.shop_id = response.data.data.shop_id

					let params = new URLSearchParams()
					params.append('shop_id', self.params.shop_id)
					params.append('before_start_date', moment(self.params.date).format('YYYY-MM-DD'))
					params.append('after_start_date', moment(self.params.date).format('YYYY-MM-DD'))

					StaffWorkSchedule.all(params).then(function (response) {
						self.work_schedules = response.data.data
					})
				})
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				let self = this

				$(document).on('change', '#shop_work_schedule_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}

					if ($(this).prop('checked') == true) {
						// 予約枠チェック
						let params = new URLSearchParams()
						params.append('id', $(this).closest('.data_row').data('id'))

						StaffWorkSchedule.one(params).then(response => {
							let staff_id = response.data.data.staff_id
							let params = new URLSearchParams()
							params.append('response_staff_id', staff_id)
							params.append('before_date', moment(self.params.date).format('YYYY-MM-DD'))
							params.append('after_date', moment(self.params.date).format('YYYY-MM-DD'))

							ShopReservation.one(params).then(response => {
								if (response.data.data != null) {
									alert('予約枠が割り当てられているため不在にできません。※ゴミ箱内も要確認')
									$(this).closest('.data_row').removeClass('data_row_before_save')
									$(this).prop('checked', false)
									// return
								}

								/*
								let params = new URLSearchParams()
								params.append('sub_response_staff_id', staff_id)
								params.append('before_date', moment(self.params.date).format('YYYY-MM-DD'))
								params.append('after_date', moment(self.params.date).format('YYYY-MM-DD'))

								ShopReservation.one(params).then(response => {
									if (response.data.data != null) {
										alert('予約枠が割り当てられているため不在にできません。※ゴミ箱内も要確認')
										$(this).closest('.data_row').removeClass('data_row_before_save')
										$(this).prop('checked', false)
									}
								})

								*/
							})
						})
					}
				})
			},
			isMobile () {
				let ua = navigator.userAgent

				if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0) {
					return true
				} else {
					return false
				}
			}
		},
		created () {
			this.loadParams()
			this.loadStaffs()
			this.loadWorkSchedules()
		},
		mounted () {
			this.registerDataChangeEvent()

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			})

			Sortable.create($('#shop_work_schedule_table .tbody')[0], {
				handle: '.data_row_handle',
				draggable: '.data_row',
				dragoverBubble: true,
				onEnd: function (event) {
					$(event.item).addClass('data_row_before_save')
				},
				onMove: function (event) {
					$(event.item).addClass('data_row_before_save')
				}
			})

			$('#create_form_start').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#create_form_end').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#edit_form_start').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#edit_form_end').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						self.need_confirm_alert = false
						UIkit.modal($('#create_form_dialog')).hide()
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}
			})

			$('#edit_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						self.need_confirm_alert = false
						UIkit.modal($('#edit_form_dialog')).hide()
					}
				} else {
					UIkit.modal($('#edit_form_dialog')).hide()
				}
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<style lang="scss" scoped>
	input[type="date"]::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="time"]::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	#shop_work_schedule_table_wrap {
		width: 100% !important;
		padding: 0;
	}

	#shop_work_schedule_table {
		width: 100%;
		user-select: none;
		display: inline-table;


		.thead {
			display: table-header-group;

			.row {
				span {
					color: #999;
				}
			}
		}

		.tbody {
			display: table-row-group
		}

		.thead,
		.tbody {

			.row {
				width: 100%;
				display: flex;
				border: solid 1px #DDD;
				border-left: none;
				border-right: none;

				span {
					flex-grow: 1;
					width: 25%;
					padding: 16px 12px;
					border: solid 1px #DDD;
					border-top: none;
					border-bottom: none;
					text-align: center;
					vertical-align: middle;
					font-size: 0.875rem;

					&:focus {
						background: #EEE;
					}
				}

				&:nth-child(even) {
					background: #f8f8f8;
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6 !important;
		}

		.sortable-ghost {
			opacity: 0;
		}
	}

	#wrap1 {
		height: 100%;
		overflow-y: hidden;
	}

	#wrap2 {
		overflow-y: auto;
		height: 100%;
	}

	#create_form_dialog,
	#edit_form_dialog {
		z-index: 1005;
	}
</style>
<style lang="scss">
	.vdp-datepicker {
		z-index: 999;
	}

	.time-picker {
		width: 100% !important;

		input {
			width: 100% !important;
		}
	}

	.el-date-editor {
		width: 100% !important;
	}
	.el-input__inner {
		border-radius: 0;
	}

</style>



// WEBPACK FOOTER //
// src/components/page/ShopWorkSchedulePage.vue